import { Box, Container, Divider, Grid, Typography } from "@mui/material";
import { designTokens } from "../../theme/designTokens";
import { serviceSections, servicesHero } from "../../theme/servicesContent";
import ServiceSection from "./ServiceSection";

const { colors, fonts, spacing } = designTokens;

const Services = () => (
  <Box sx={{ pt: { xs: 10, md: 12 } }}>
    <Container maxWidth={spacing.containerMax} sx={{ pb: { xs: 4, md: 6 } }}>
      <Grid container spacing={{ xs: 3, md: 6 }} alignItems="flex-start">
        <Grid item xs={12} md={6}>
          <Typography
            variant="h3"
            component="h1"
            sx={{
              color: colors.textPrimary,
              fontWeight: fonts.weights.bold,
              fontSize: { xs: "2rem", md: "2.5rem" },
              textAlign: { xs: "center", md: "left" },
            }}
          >
            {servicesHero.title}
          </Typography>
          <Divider
            sx={{
              backgroundColor: colors.primary,
              width: { xs: 130, md: 162 },
              height: 4,
              my: 2,
              mx: { xs: "auto", md: 0 },
              borderRadius: "4px",
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography
            variant="body1"
            sx={{
              color: colors.textPrimary,
              fontSize: "1rem",
              lineHeight: "26px",
              textAlign: { xs: "justify", md: "left" },
            }}
          >
            {servicesHero.intro}
          </Typography>
        </Grid>
      </Grid>
    </Container>

    {serviceSections.map((section) => (
      <ServiceSection key={section.title} {...section} />
    ))}
  </Box>
);

export default Services;
